<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="sizeLg ? 'lg-fix-h' : 'md'" :ariaLabel="header">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 60vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
            <div v-if="getClientActive" class="w-full mb-4 md:mb-0 ">
              <div v-if="(role === 7 || role === 8 || role === 3)">

                <AccessibleElSelect
                  prop="idCliente"
                  v-model="form.idCliente"
                  :options="clientes.map(c => ({ id: c.idCliente, name: c.Nombre }))"
                  id-prefix="importgeneric"
                >
                  <template #label>
                    <base-obligatory-icon/>{{$t('clients.entity_name')}}
                  </template>
                </AccessibleElSelect>
                
              </div>
            </div>
            <div class="mb-4" v-if="activateSwitch1 || activateSwitch2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">
                {{$t('imports.excel_import_options')}}
              </label>
              <div class="flex flex-col lg:flex-row lg:space-x-4 mt-2">
                <div v-if="activateSwitch1">
                  <label for="generic-import-switch1" class="sr-only">
                    {{labelSwitch1}}. {{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}
                  </label>
                  <el-switch 
                    id="generic-import-switch1"
                    :aria-label="labelSwitch1"
                    class="switch-text break-normal both-switch mb-2 lg:mb-0" 
                    v-model="form.switch1" 
                    :active-text="labelSwitch1"/>
                </div>
                <div v-if="activateSwitch2">
                  <label for="generic-import-switch2" class="sr-only">
                    {{labelSwitch2}}. {{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}
                  </label>
                  <el-switch 
                    id="generic-import-switch2"
                    :aria-label="labelSwitch2"
                    class="switch-text break-normal both-switch" 
                    v-model="form.switch2" 
                    :active-text="labelSwitch2"/>
                </div>
              </div>
            </div>
            <div class="mb-0 flex gap-x-6">
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('imports.excel_csv_to_import')}}</label>
                <div class="flex justify-center w-full">
                  <el-form-item prop="files" ref="uploadexcel" class="mb-0">
                    <Upload
                      role="button"
                      ref="upload"
                      accept=".xlsx,.csv"
                      class="bg-white dark:bg-darkblue-900 "
                      :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                      drag
                      action="#"
                      :show-file-list="false"
                      :multiple="false"
                      :auto-upload=false
                      :on-remove="handleRemove"
                      :on-change="handleChange"
                      :on-exceed="handleOnExceed"
                      >
                      <i class="el-icon-upload"></i>
                      <p v-if="files && files.length" class="el-upload__text"><em>{{this.fileNames}}</em></p>
                      <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', 1)"></div>
                    </Upload>
                  </el-form-item>
                </div>
                <div class="flex items-center gap-x-2 justify-center w-full mt-2">
                  <label v-if="!secondaryTemplate" class="text-sm text-secondary-600 block mb-1">{{$t('imports.template_to_import')}}</label>
                  <label v-else class="text-sm text-secondary-600 block mb-1">{{$t('imports.template_to_import_plural')}}</label>
                  <base-button-icon
                    :ariaLabel="$t('imports.download_template')"
                    @click="downloadTemplate"
                    size="xs"
                    name="download"
                    class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full inline-block "
                  />
                </div>
              </div>
            </div>
          
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="w-full flex items-center gap-x-2">
        <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getClients } from '@/services/clients/getClients'
import { Upload } from 'element-ui'
import { i18n } from '@/i18n'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'import-generic-dialog',
  components: {
    BaseDialogButton,
    Upload,
    AccessibleElSelect,
  },
  props: {
    header: {
      type: String,
      default: i18n.t('app/important')
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    secondaryTemplate: {
      type: Boolean,
      default: false
    },
    mandatoryClient: {
      type: Boolean,
      default: false
    },
    activateSwitch1: {
      type: Boolean,
      default: false
    },
    labelSwitch1: {
      type: String,
      default: i18n.t('app/update_entities')
    },
    activateSwitch2: {
      type: Boolean,
      default: false
    },
    labelSwitch2: {
      type: String,
      default: i18n.t('app/update_entities')
    },
    sizeLg: {
      type: Boolean,
      default: false
    },
    getClientActive: {
      type: Boolean,
      default: true
    },
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      files: [],
      form: {
        value: '',
        switch1: false,
        switch2: false,
        idCliente: null,
      },
      maxFiles: 1,
      maxSizeFile: 5242880, // Bytes (5MB)
      msgTooltip: '',
      clientes: [],
      rules: {
        idCliente: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        files: [
          {
            message: this.$i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNames) {
                callback(new Error(i18n.t('validation.complete')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: '.xlsx' }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.files.forEach(archivo => {
                if (archivo.name.length < 6 || 
                  (archivo.name.substr(archivo.name.length - 5).toUpperCase() !== '.XLSX' && archivo.name.substr(archivo.name.length - 4).toUpperCase() !== '.CSV')) {
                  invalidExtension = true
                }
              })
              if (invalidExtension) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.xlsx' })))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            message: this.$i18n.t('validation.exceed_size_files') + ' (' + this.maxMB + ' MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNames && this.files.filter(x => x.size > this.maxSizeFile).length > 0) {
                callback(new Error(i18n.t('validation.exceed_size_files')))
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.idCliente = null
      this.files = []
      if (value) {
        if (this.getClientActive) this.loadClients()
      } else {
        this.clientes = []
      }
    }
  },
  mounted: async function () {
  },
  computed: {
    clientFilter: function () {
      return this.$store.getters['app/idClienteFilterUpload']?.idCliente
    },
    maxMB () {
      return this.maxSizeFile / 1024 / 1024
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    fileNames () {
      if (this.files === null || this.files.length === 0) {
        return ''
      } else if (this.files.length === 1) {
        return this.files[0].name
      } else {
        return '(' + this.files.length + ') ' + i18n.t('app.files')
      }
    },
  },
  methods: {
    handleChange: function (file) {
      this.$refs.uploadexcel.clearValidate()
      this.files = []
      this.files.push(file)
    },
    handleRemove: function (file) {
      this.files = this.files.filter(x => x.uid !== file.uid)
    },
    handleOnExceed: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: this.maxFilesAdj }), 'warning')
    },
    loadClients: async function () {
      if (this.role === 7 || this.role === 8 || this.role === 3) {
        const dataClients = await getClients()
        if (dataClients.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
        } else {
          this.clientes = dataClients.Clientes
          this.form.idCliente = this.clientFilter || ''
        }
      }
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.files[0], this.form)
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
    downloadTemplate () {
      if (this.role !== 2 && this.mandatoryClient && !this.form.idCliente) {
        this.$refs.ruleForm.validateField('idCliente')
        this.doFeedback(i18n.t('imports.not_valid_download_template_client_needed'))
        return
      }
      if (this.mandatoryClient) {
        this.$emit('downloadTemplate', this.form.idCliente)
      } else {
        this.$emit('downloadTemplate')
      }
    },
  }
}
</script>
